import cn from "classnames";
import { cloneElement, useState, useRef } from "react";
// import DatePicker from "@ui-kit/DatePicker/DatePicker";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";

import s from "./Popper.module.scss";

const Popper = ({
  className,
  classNameElement,
  classNamePopper,
  triggerElement,
  isRenderPoper = true,
  popperContent = null,
  placement = "bottom-start",
  isInitOpen = false,
  onClose = null,
  onClick = null,
}) => {
  const [isPopperOpen, setIsPopperOpen] = useState(() => isInitOpen);

  const elementRef = useRef(null);
  const popperRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);

  const popper = usePopper(elementRef.current, popperElement, {
    placement,
    // strategy: "fixed",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 13],
        },
      },
      // {
      //   name: "flip",
      //   options: {
      //     flipVariations: false, // true by default
      //   },
      // },
      // {
      //   name: "flip",
      //   options: {
      //     allowedAutoPlacements: [], // by default, all the placements are allowed
      //   },
      // },
    ],
  });

  const positionPoper = {
    "bottom-start": s.bottomStart,
    "bottom-end": s.bottomEnd,
    "top-start": s.topStart,
    "top-end": s.topEnd,
  };

  const closePopper = () => {
    setIsPopperOpen(false);
    onClose && onClose();
  };

  const handleButtonClick = () => {
    setIsPopperOpen(!isPopperOpen);
    onClick && onClick();
  };

  useClickAway(popperRef, () => {
    if (isPopperOpen) {
      closePopper();
    }
  });

  return (
    <div className={cn(className)}>
      <div
        ref={elementRef}
        onClick={handleButtonClick}
        className={cn(s.element, classNameElement)}
      >
        {triggerElement}
      </div>
      {isPopperOpen && popperContent && !!isRenderPoper && (
        <div
          ref={(node) => {
            setPopperElement(node);
            popperRef.current = node;
          }}
          style={{
            ...popper.styles.popper,
            zIndex: 10,
          }}
          className={cn(s.popper, positionPoper[placement], classNamePopper)}
          {...popper.attributes.popper}
        >
          <div className={s.triangleWrap}>
            <div className={s.triangle} />
          </div>
          {cloneElement(popperContent, { closePopper })}
        </div>
      )}
    </div>
  );
};

export default Popper;
